import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import fetcher from '../../../Helpers/Fetcher/fetchApi';
import Layout from '../../../Components/Layout/Layout';
import { Link, useNavigate } from 'react-router-dom';
import Toaster from '../../../Components/Toaster/Toaster';
import { Button } from 'react-bootstrap';
import {
  EXHIBITOR_USER_SUCCESS,
  EXHIBITOR_USER_FAILED,
} from '../../../Helpers/Constant';
import Loader from '../../../Components/Spinner/Loader';
import { useExhibitorAuthContext } from '../../../Context/AuthContex/ExhibitorAuthContext';
import InputField from '../../../Components/Common/InputField';

interface inputForm {
  email: string;
  password: string;
}

const ExhibitorLogin = () => {
  const { dispatch, isLoading, setIsLoading } = useExhibitorAuthContext();
  const Toast = Toaster();
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm<inputForm>();
  const [passwordType, setPasswordType] = useState('password');

  const onSubmit: SubmitHandler<inputForm> = async (data) => {
    try {
      setIsLoading?.(true);
      const res = await fetcher.post({
        url: '/api/auth/fair-member/login',
        contentType: 'application/json',
        body: data,
      });

      if (res.success) {
        Toast.fire({
          icon: 'success',
          title: `successfully login`,
        });
        dispatch?.({
          type: EXHIBITOR_USER_SUCCESS,
          payload: { ...res.data, token: res.token },
        });
        localStorage.setItem('toab_exibitor_token', res.token);
        setIsLoading?.(false);
        navigate('/profile');
      } else {
        Toast.fire({
          icon: 'error',
          title: res.message,
        });
        setIsLoading?.(false);
        dispatch?.({ type: EXHIBITOR_USER_FAILED });
      }
    } catch (error) {
      setIsLoading?.(false);
      dispatch?.({ type: EXHIBITOR_USER_FAILED });
    }
  };

  return (
    <>
      <Layout>
        <div className='login-wrapper'>
          <div className='login-div  mt-3'>
            <div className='login-page'>
              <h1 className='text-center'>Exhibitor Login</h1>
              <div className='login-form'>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <InputField
                      label='Enter your email'
                      register={register('email')}
                      type='text'
                      isRequired
                      placeholder='Enter your email address'
                    />
                  </div>
                  <div className='pt-3'>
                    <InputField
                      label='Enter your password'
                      register={register('password')}
                      type={passwordType}
                      isRequired
                      placeholder='Enter your password'
                    />
                  </div>
                  <div className=' pt-2 d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center'>
                      <input
                        type='checkbox'
                        onClick={() => {
                          passwordType === 'password'
                            ? setPasswordType('text')
                            : setPasswordType('password');
                        }}
                      />
                      <p className='ps-2'>Show password</p>
                    </div>
                    <Link
                      to='/forget-password?type=forget_fair'
                      style={{ textDecoration: 'none' }}
                    >
                      <p className='text-primary'>Forgot password</p>
                    </Link>
                  </div>

                  <div>
                    {isLoading ? (
                      <Loader css={'w-100 mt-3 text-white '} />
                    ) : (
                      <Button
                        type='submit'
                        className='w-100 mt-3 submit-button common-btn'
                      >
                        Exhibitor Login
                      </Button>
                    )}
                  </div>
                  <div className='d-flex align-items-center my-4'>
                    <div className='flex-grow-1 border-top border-secondary'></div>
                    <span className='mx-2 py-2  text-black '>
                      <Link
                        to='/book-your-space'
                        className='text-decoration-none'
                      >
                        Exhibitor register
                      </Link>
                    </span>
                    <div className='flex-grow-1 border-top border-secondary'></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ExhibitorLogin;
